<template>
  <div v-if="!$auth.loggedIn && mode === 'full'" v-qa="'calculator-tabs'" class="calculator__tabs">
    <div
      v-qa="'calculator-tab0'"
      :class="{ active: tab === 0 }"
      class="calculator__tab"
      @click="tab = 0">
      <template><slot name="first"/></template>
    </div>
    <div
      v-qa="'calculator-tab1'"
      :class="{ active: tab === 1 }"
      class="calculator__tab"
      @click="tab = 1">
      <template><slot name="repeated"/></template>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    mode: {
      type: String,
      default: 'full',
    },
  },
  computed: {
    tab: {
      get() {
        return this.$store.state.arithmetic.current.tab;
      },
      set(value) {
        this.setValue({ key: 'tab', value });
        this.$emit('change', value);
      },
    },
  },
  methods: {
    ...mapMutations('arithmetic', ['setValue']),
  },
};
</script>

<style lang="scss" scoped>
.calculator {
  &__tabs {
    display: flex;
  }

  &__tab {
    @extend %centered;
    padding: 15px 20px;
    width: 50%;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.3s;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }

    &:not(.active) {
      color: #7e8287;
      background-color: #ebedee;
      font-weight: 400;
    }
  }
}
</style>
